import React, { Component } from "react";
import Popup from "../components/popup";

class LoginComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      error: "",
      success: null,
      redirect: false,
    };
  }

  clearInputs = () =>
    document
      .querySelectorAll(
        'input.error:not([type="submit"]):not([type="password"])'
      )
      .forEach((val) => (val.value = ""));

  handleErrors = (err) => {
    const email = document.querySelector('input[type="email"]');
    const password = document.querySelector('input[type="password"]');

    email.classList.remove("error");
    password.classList.remove("error");

    switch (err) {
      case 0:
        /* eslint-disable-next-line */
        password.offsetHeight;
        password.classList.add("error");
        break;
      case 3:
        /* eslint-disable-next-line */
        email.offsetHeight;
        email.classList.add("error");
        break;
    }
  };

  handleSubmit = (e) => {
    e.preventDefault();

    // Post req to backend
    fetch(
      this.props.url +
        (this.props.isLunda
          ? "/api/lundarundan/account/signin"
          : "/api/account/signin"),
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: e.target.email.value,
          password: e.target.password.value,
        }),
      }
    )
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          this.setState({
            error: json.mes,
            isLoading: false,
            success: true,
            redirect: true,
          });
          this.props.handleToken(json);
        } else {
          this.handleErrors(json.errCode);
          this.setState({
            error: json.mes,
            isLoading: false,
            success: false,
          });
          this.clearInputs();
        }
      });
  };

  handlePasswordChange = (e) => {
    e.preventDefault();

    this.setState({
      isLoading: true,
    });

    // Post req to backend
    fetch(
      this.props.url +
        (this.props.isLunda
          ? "/api/lundarundan/user/forgot/password"
          : "/api/user/forgot/password"),
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: e.target.email.value,
        }),
      }
    )
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          this.setState({ error: json.mes, success: true, isLoading: false });
          this.hidePopup();
        } else {
          this.setState({
            error: json.mes,
            success: false,
            isLoading: false,
          });
        }
      });
  };

  hidePopup = () => {
    const wrapper = document.querySelector(".popup-wrapper.active");

    if (wrapper) {
      wrapper.classList.remove("active");
    }
  };

  render() {
    return (
      <div className="loginComponent">
        {this.state.error && <p>{this.state.error}</p>}
        <form onSubmit={(e) => this.handleSubmit(e)}>
          <div className="form">
            <div className="text-input" id="abId0.12727693608323598">
              <p className="label">Email</p>
              <input type="email" placeholder="namn@namnsson.se" name="email" />
            </div>
            <div className="container">
              <div className="text-input" id="abId0.015557523448827437">
                <p className="label">Lösenord</p>
                <input
                  minLength="6"
                  type="password"
                  placeholder=""
                  name="password"
                />
              </div>

              <p className="forgotpassword" id="popup-button">
                Glömt lösenordet?
              </p>
            </div>
          </div>
          <input type="submit" value="Logga in" />
        </form>
        <Popup>
          {!this.state.isLoading ? (
            <form onSubmit={(e) => this.handlePasswordChange(e)}>
              <h1>Glömt lösenord</h1>
              <div className="text-input" id="abId0.015557523448827437">
                <p className="label">Email</p>
                <input
                  type="email"
                  placeholder="namn@namnsson.se"
                  name="email"
                />
              </div>
              <input type="submit" data-value="Spara" value="Skicka email" />
            </form>
          ) : (
            <div className="sk-circle">
              <div className="sk-circle1 sk-child"></div>
              <div className="sk-circle2 sk-child"></div>
              <div className="sk-circle3 sk-child"></div>
              <div className="sk-circle4 sk-child"></div>
              <div className="sk-circle5 sk-child"></div>
              <div className="sk-circle6 sk-child"></div>
              <div className="sk-circle7 sk-child"></div>
              <div className="sk-circle8 sk-child"></div>
              <div className="sk-circle9 sk-child"></div>
              <div className="sk-circle10 sk-child"></div>
              <div className="sk-circle11 sk-child"></div>
              <div className="sk-circle12 sk-child"></div>
            </div>
          )}
        </Popup>
      </div>
    );
  }
}

export default LoginComponent;
